// extracted by mini-css-extract-plugin
export default {"search-bar":"search-input_styles_search-bar__hqmQp","search-bar-input":"search-input_styles_search-bar-input__0rrtR"};